import { get, post, put, deleted } from '../utils/http';

export function unsubscribeCustomer(param, code) {
    return post(`${code}subscribe/unsubscribe_with_token`, param);
};

export function getUnsubscribeToken(param, code) {
    return post(`${code}subscribe/get_subscribe_topics_with_token`, param);
};

